import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isClickedFilters: false,
  isHolidayApiCall: false,
  position: { top: 0, left: 0 },
  selectedRegion: {},
  voucherResponse: {},
  offerDetails: [],
  isRetrieveBasketApiCall: false,
  storePayload: "",
  showPopup: false,
  editSearch: false,
};

const commonStateSlice = createSlice({
  name: "commonState",
  initialState: initialState,
  reducers: {
    setIsClickedFilters(state, action) {
      state.isClickedFilters = action?.payload;
    },
    setIsHolidayApiCall(state, action) {
      state.isHolidayApiCall = action?.payload;
    },
    setSelectedRegion(state, action) {
      state.selectedRegion = action?.payload;
    },
    setPosition(state, action) {
      state.position = action?.payload;
    },
    setVouchereResponse(state, action) {
      state.voucherResponse = action?.payload;
    },
    setOfferDetails(state, action) {
      state.offerDetails = action?.payload;
    },
    setIsRetrieveBasketApiCall(state, action) {
      state.isRetrieveBasketApiCall = action?.payload;
    },
    setStorePayload(state, action) {
      state.storePayload = action?.payload;
    },
    setShowPopup(state, action) {
      state.showPopup = action?.payload;
    },
    setEditSearch(state, action) {
      state.editSearch = action?.payload;
    },
  },
});

export const {
  setIsClickedFilters,
  setIsHolidayApiCall,
  setSelectedRegion,
  setPosition,
  setVouchereResponse,
  setOfferDetails,
  setIsRetrieveBasketApiCall,
  setStorePayload,
  setShowPopup,
  setEditSearch,
} = commonStateSlice.actions;
export default commonStateSlice.reducer;
